import { render, staticRenderFns } from "./CampaignViewer.vue?vue&type=template&id=b0551fe0&"
import script from "./CampaignViewer.vue?vue&type=script&lang=js&"
export * from "./CampaignViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports